module.exports = __webpack_public_path__ + "static/media/splash-bg-medium.0cd7c697.jpg";